import { User, UserEmail, UserName, UserPassword } from 'framework/users'
import { EcommerceService } from 'services'

class UserService extends EcommerceService {
  private user: User

  constructor(user: User = null as unknown as User) {
    super()
    this.user = user
  }

  setUser(user: User): UserService {
    this.user = user
    return this
  }

  getUser() {
    return this.user
  }

  auth = (email: string, password: string) => {
    const payload = {
      iat: this.generateIat(),
      email,
      password,
    }

    const header = this.generateHeaderHash()
    const payloadHash = window.btoa(JSON.stringify(payload))
    const signature = this.generateSignature(payloadHash)
    const hash = `${header}.${payloadHash}.${signature}`

    const client = this.setUrl('/users/login').post(payload, {
      headers: {
        Authorization: `Bearer ${hash}`,
      },
    })

    return client
  }

  changePassword = (password: UserPassword, email: UserEmail = '' as unknown as UserEmail) => {
    const payload = {
      iat: this.generateIat(),
      email,
      password,
    }

    const header = this.generateHeaderHash()
    const payloadHash = window.btoa(JSON.stringify(payload))
    const signature = this.generateSignature(payloadHash)
    const hash = `${header}.${payloadHash}.${signature}`
    const { id } = this.getUser()
    const client = this.setUrl(`/customers/${id}/update-password`).post(payload, {
      headers: {
        Authorization: `Bearer ${hash}`,
      },
    })

    return client
  }

  changePasswordFromForgot = (password: UserPassword, email: UserEmail = '' as unknown as UserEmail) => {
    const payload = {
      iat: this.generateIat(),
      email,
      password,
    }

    const client = this.setUrl('/users/update-password').post(payload)

    return client
  }

  createUser = (
    name: UserName,
    document: string,
    email: UserEmail,
    phone: string,
    password: UserPassword,
    birthday: string,
    fantasy_name: string,
    ins_estadual: string,
    personType: string,
    is_exempt_state: boolean,
    name_company: string,
  ) => {
    const payload = {
      iat: this.generateIat(),
      user: {
        password,
      },
      customer: {
        name,
        document,
        person_type: 'PF',
        email,
        birthday,
        phone,
        fantasy_name,
        ins_estadual,
        personType,
        is_exempt_state,
        name_company,
      },
      addresses: [
        {
          type: 'ENTREGA',
          city_id: 1,
          street: 'Rua Raymundo Nina',
          postal_code: '82920010',
          neighborhood: 'Cristo Rei',
          complement: 'Casa',
        },
        {
          type: 'COBRANCA',
          city_id: 1,
          street: 'Rua Raymundo Nina',
          postal_code: '82920010',
          neighborhood: 'Cristo Rei',
          complement: 'Casa',
        },
      ],
    }

    const header = this.generateHeaderHash()
    const payloadHash = window.btoa(JSON.stringify(payload))
    const signature = this.generateSignature(payloadHash)
    const hash = `${header}.${payloadHash}.${signature}`
    const client = this.setUrl('/customers').post(payload, {
      headers: {
        Authorization: `Bearer ${hash}`,
      },
    })

    return client
  }

  requestRecoverPassword = (email: UserEmail) => {
    const payload = {
      iat: this.generateIat(),
      email,
    }
    const req = this.setUrl('/users/password-reset').post(payload)

    return req
  }

  recoverPasswordCheckToken = (email: UserEmail, token: string) => {
    const payload = {
      iat: this.generateIat(),
      email,
      token,
    }
    const req = this.setUrl('/users/password-reset-validation').post(payload)

    return req
  }

  updateUserProfile = (
    email: string,
    phone: string,
    name: string,
    birthday: string,
    fantasy_name: string,
    name_company: string,
    ins_estadual: string,
  ) => {
    const { id } = this.getUser()
    const payload = {
      email,
      phone: phone.replace(/\D/g, ''),
      name,
      birthday,
      fantasy_name,
      name_company,
      ins_estadual,
    }
    const req = this.setUrl(`/customers/${id}`).post(payload)

    return req
  }

  getCustomerData = () => {
    const { id } = this.getUser()
    const req = this.setUrl(`/customers/${id}`).get()
    return req
  }

  getAddresses(userId: string) {
    const url = `/customers/${userId}/address`
    const req = this.setUrl(url).get()
    return req
  }

  getSubscriptions(userId: string) {
    const url = `/customers/${userId}/subscription`
    const req = this.setUrl(url).get()
    return req
  }

  cancelSubscription(subscriptionId: number) {
    const url = `/customers/${subscriptionId}/subscription`
    const req = this.setUrl(url).delete()
    return req
  }

  editSubscription(subscriptionId: number, data: any) {
    const url = `/customers/${subscriptionId}/subscription`
    const req = this.setUrl(url).put(data)
    return req
  }

  generateCardId(cardData: Object) {
    const url = `/card`
    const req = this.setUrl(url).post({hash: cardData})
    return req
  }
}

export default UserService
